import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_BRANDS_SPECIALITY_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const BrandSpecialityReport = lazy(() => import('../../../screens/BrandSpecialityReport')
  .then(module => ({default: module.BrandSpecialityReport})));

const BrandSpecialityReportNavigation = [
  {
    path: ROUTE_BRANDS_SPECIALITY_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <BrandSpecialityReport />
      </Suspense>
    ),
  },
];

export default BrandSpecialityReportNavigation;
